module.exports = __webpack_public_path__ + "img/img_no_result.8d9985c.svg";